export default "/static/static_storage_tiny.png";